import React, { useEffect, useState, createContext, useMemo } from 'react';

import { apiContainer } from '@vlabs/api-bindings';

import { filters } from './defaultAnalyticsFilters';

export const QueueEventsContext = createContext();

export function QueueEventsContextProvider({ children }) {
  const [events, setEvents] = useState({});

  useEffect(() => {
    apiContainer.lunaClient.generalWs.connect(filters, null, { startClosed: false });
    apiContainer.lunaClient.generalWs.onmessage = async (event) => {
      setEvents((prev) => {
        return ({
          ...prev,
          [event.event.stream_id]: event.event,
        });
      });
    };
    return () => apiContainer.lunaClient.generalWs.disconnectAll();
  }, []);

  const queueContextValue = useMemo(() => ({
    events,
  }), [events]);

  return (
    <QueueEventsContext.Provider value={queueContextValue}>
      {children}
    </QueueEventsContext.Provider>
  );
}
